import type { FateCard } from '../types';

export const FATE_CARDS: FateCard[] = [
  // === 好运类（4张） ===
  {
    id: 'fate_carnival',
    name: '🎆 嘉年华',
    emoji: '🎆',
    type: 'fate',
    category: 'good',
    description: '所有玩家获得200金币！',
    effectCategory: 'economy',
  },
  {
    id: 'fate_rainbow',
    name: '🌈 彩虹桥',
    emoji: '🌈',
    type: 'fate',
    category: 'good',
    description: '如果正在监狱中：立即释放+获得200金币；不在监狱：获得200金币',
    effectCategory: 'economy',
  },
  {
    id: 'fate_windfall',
    name: '🍀 天降横财',
    emoji: '🍀',
    type: 'fate',
    category: 'good',
    description: '获得300金币',
    effectCategory: 'economy',
  },
  {
    id: 'fate_treasure',
    name: '💎 宝藏发现',
    emoji: '💎',
    type: 'fate',
    category: 'good',
    description: '获得一张随机反转卡',
    effectCategory: 'card',
  },

  // === 厄运类（3张） ===
  {
    id: 'fate_tornado',
    name: '🌪 龙卷风',
    emoji: '🌪',
    type: 'fate',
    category: 'bad',
    description: '随机失去一座地产（归还市场）',
    effectCategory: 'property',
  },
  {
    id: 'fate_lightning',
    name: '⚡ 天罚',
    emoji: '⚡',
    type: 'fate',
    category: 'bad',
    description: '资产最高的玩家失去一座最贵的地产（归还市场）',
    effectCategory: 'property',
  },
  {
    id: 'fate_pickpocket',
    name: '🦝 扒手光顾',
    emoji: '🦝',
    type: 'fate',
    category: 'bad',
    description: '损失200金币',
    effectCategory: 'economy',
  },

  // === 反转类（3张） ===
  {
    id: 'fate_wealth_tornado',
    name: '💰 财富龙卷风',
    emoji: '💰',
    type: 'fate',
    category: 'reverse',
    description: '场上最富和最穷玩家资产互换30%',
    effectCategory: 'economy',
  },
  {
    id: 'fate_masquerade',
    name: '🎭 假面舞会',
    emoji: '🎭',
    type: 'fate',
    category: 'reverse',
    description: '所有玩家的身份牌向左传递一位',
    effectCategory: 'identity',
  },
  {
    id: 'fate_thief_king',
    name: '👑 皇帝轮流做',
    emoji: '👑',
    type: 'fate',
    category: 'reverse',
    description: '当前回合顺序反转（之后恢复）',
    effectCategory: 'rule',
  },
];
